module.exports = __webpack_public_path__ + "img/consultation_image.e2097bd3.jpg";